import { CountryResponse } from '../types'

export const COUNTRIES_LIST: CountryResponse[] = [
	{
		name: 'Afghanistan',
		alpha2Code: 'AF',
		callingCode: '+93',
		flag: 'https://upload.wikimedia.org/wikipedia/commons/5/5c/Flag_of_the_Taliban.svg',
	},
	{
		name: 'Albania',
		alpha2Code: 'AL',
		callingCode: '+355',
		flag: 'https://flagcdn.com/al.svg',
	},
	{
		name: 'Algeria',
		alpha2Code: 'DZ',
		callingCode: '+213',
		flag: 'https://flagcdn.com/dz.svg',
	},
	{
		name: 'American Samoa',
		alpha2Code: 'AS',
		callingCode: '+1',
		flag: 'https://flagcdn.com/as.svg',
	},
	{
		name: 'Andorra',
		alpha2Code: 'AD',
		callingCode: '+376',
		flag: 'https://flagcdn.com/ad.svg',
	},
	{
		name: 'Angola',
		alpha2Code: 'AO',
		callingCode: '+244',
		flag: 'https://flagcdn.com/ao.svg',
	},
	{
		name: 'Antarctica',
		alpha2Code: 'AQ',
		callingCode: '+672',
		flag: 'https://flagcdn.com/aq.svg',
	},
	{
		name: 'Argentina',
		alpha2Code: 'AR',
		callingCode: '+54',
		flag: 'https://flagcdn.com/ar.svg',
	},
	{
		name: 'Armenia',
		alpha2Code: 'AM',
		callingCode: '+374',
		flag: 'https://flagcdn.com/am.svg',
	},
	{
		name: 'Aruba',
		alpha2Code: 'AW',
		callingCode: '+297',
		flag: 'https://flagcdn.com/aw.svg',
	},
	{
		name: 'Australia',
		alpha2Code: 'AU',
		callingCode: '+61',
		flag: 'https://flagcdn.com/au.svg',
	},
	{
		name: 'Austria',
		alpha2Code: 'AT',
		callingCode: '+43',
		flag: 'https://flagcdn.com/at.svg',
	},
	{
		name: 'Azerbaijan',
		alpha2Code: 'AZ',
		callingCode: '+994',
		flag: 'https://flagcdn.com/az.svg',
	},
	{
		name: 'Bahrain',
		alpha2Code: 'BH',
		callingCode: '+973',
		flag: 'https://flagcdn.com/bh.svg',
	},
	{
		name: 'Bangladesh',
		alpha2Code: 'BD',
		callingCode: '+880',
		flag: 'https://flagcdn.com/bd.svg',
	},
	{
		name: 'Belarus',
		alpha2Code: 'BY',
		callingCode: '+375',
		flag: 'https://flagcdn.com/by.svg',
	},
	{
		name: 'Belgium',
		alpha2Code: 'BE',
		callingCode: '+32',
		flag: 'https://flagcdn.com/be.svg',
	},
	{
		name: 'Belize',
		alpha2Code: 'BZ',
		callingCode: '+501',
		flag: 'https://flagcdn.com/bz.svg',
	},
	{
		name: 'Benin',
		alpha2Code: 'BJ',
		callingCode: '+229',
		flag: 'https://flagcdn.com/bj.svg',
	},
	{
		name: 'Bhutan',
		alpha2Code: 'BT',
		callingCode: '+975',
		flag: 'https://flagcdn.com/bt.svg',
	},
	{
		name: 'Bolivia (Plurinational State of)',
		alpha2Code: 'BO',
		callingCode: '+591',
		flag: 'https://flagcdn.com/bo.svg',
	},
	{
		name: 'Bonaire, Sint Eustatius and Saba',
		alpha2Code: 'BQ',
		callingCode: '+599',
		flag: 'https://flagcdn.com/bq.svg',
	},
	{
		name: 'Bosnia and Herzegovina',
		alpha2Code: 'BA',
		callingCode: '+387',
		flag: 'https://flagcdn.com/ba.svg',
	},
	{
		name: 'Botswana',
		alpha2Code: 'BW',
		callingCode: '+267',
		flag: 'https://flagcdn.com/bw.svg',
	},
	{
		name: 'Bouvet Island',
		alpha2Code: 'BV',
		callingCode: '+47',
		flag: 'https://flagcdn.com/bv.svg',
	},
	{
		name: 'Brazil',
		alpha2Code: 'BR',
		callingCode: '+55',
		flag: 'https://flagcdn.com/br.svg',
	},
	{
		name: 'British Indian Ocean Territory',
		alpha2Code: 'IO',
		callingCode: '+246',
		flag: 'https://flagcdn.com/io.svg',
	},
	{
		name: 'Brunei Darussalam',
		alpha2Code: 'BN',
		callingCode: '+673',
		flag: 'https://flagcdn.com/bn.svg',
	},
	{
		name: 'Bulgaria',
		alpha2Code: 'BG',
		callingCode: '+359',
		flag: 'https://flagcdn.com/bg.svg',
	},
	{
		name: 'Burkina Faso',
		alpha2Code: 'BF',
		callingCode: '+226',
		flag: 'https://flagcdn.com/bf.svg',
	},
	{
		name: 'Burundi',
		alpha2Code: 'BI',
		callingCode: '+257',
		flag: 'https://flagcdn.com/bi.svg',
	},
	{
		name: 'Cabo Verde',
		alpha2Code: 'CV',
		callingCode: '+238',
		flag: 'https://flagcdn.com/cv.svg',
	},
	{
		name: 'Cambodia',
		alpha2Code: 'KH',
		callingCode: '+855',
		flag: 'https://flagcdn.com/kh.svg',
	},
	{
		name: 'Cameroon',
		alpha2Code: 'CM',
		callingCode: '+237',
		flag: 'https://flagcdn.com/cm.svg',
	},
	{
		name: 'Central African Republic',
		alpha2Code: 'CF',
		callingCode: '+236',
		flag: 'https://flagcdn.com/cf.svg',
	},
	{
		name: 'Chad',
		alpha2Code: 'TD',
		callingCode: '+235',
		flag: 'https://flagcdn.com/td.svg',
	},
	{
		name: 'Chile',
		alpha2Code: 'CL',
		callingCode: '+56',
		flag: 'https://flagcdn.com/cl.svg',
	},
	{
		name: 'China',
		alpha2Code: 'CN',
		callingCode: '+86',
		flag: 'https://flagcdn.com/cn.svg',
	},
	{
		name: 'Colombia',
		alpha2Code: 'CO',
		callingCode: '+57',
		flag: 'https://flagcdn.com/co.svg',
	},
	{
		name: 'Comoros',
		alpha2Code: 'KM',
		callingCode: '+269',
		flag: 'https://flagcdn.com/km.svg',
	},
	{
		name: 'Congo',
		alpha2Code: 'CG',
		callingCode: '+242',
		flag: 'https://flagcdn.com/cg.svg',
	},
	{
		name: 'Congo (Democratic Republic of the)',
		alpha2Code: 'CD',
		callingCode: '+243',
		flag: 'https://flagcdn.com/cd.svg',
	},
	{
		name: 'Cook Islands',
		alpha2Code: 'CK',
		callingCode: '+682',
		flag: 'https://flagcdn.com/ck.svg',
	},
	{
		name: 'Costa Rica',
		alpha2Code: 'CR',
		callingCode: '+506',
		flag: 'https://flagcdn.com/cr.svg',
	},
	{
		name: 'Croatia',
		alpha2Code: 'HR',
		callingCode: '+385',
		flag: 'https://flagcdn.com/hr.svg',
	},
	{
		name: 'Cuba',
		alpha2Code: 'CU',
		callingCode: '+53',
		flag: 'https://flagcdn.com/cu.svg',
	},
	{
		name: 'Cyprus',
		alpha2Code: 'CY',
		callingCode: '+357',
		flag: 'https://flagcdn.com/cy.svg',
	},
	{
		name: 'Czech Republic',
		alpha2Code: 'CZ',
		callingCode: '+420',
		flag: 'https://flagcdn.com/cz.svg',
	},
	{
		name: 'Denmark',
		alpha2Code: 'DK',
		callingCode: '+45',
		flag: 'https://flagcdn.com/dk.svg',
	},
	{
		name: 'Djibouti',
		alpha2Code: 'DJ',
		callingCode: '+253',
		flag: 'https://flagcdn.com/dj.svg',
	},
	{
		name: 'Ecuador',
		alpha2Code: 'EC',
		callingCode: '+593',
		flag: 'https://flagcdn.com/ec.svg',
	},
	{
		name: 'Egypt',
		alpha2Code: 'EG',
		callingCode: '+20',
		flag: 'https://flagcdn.com/eg.svg',
	},
	{
		name: 'El Salvador',
		alpha2Code: 'SV',
		callingCode: '+503',
		flag: 'https://flagcdn.com/sv.svg',
	},
	{
		name: 'Equatorial Guinea',
		alpha2Code: 'GQ',
		callingCode: '+240',
		flag: 'https://flagcdn.com/gq.svg',
	},
	{
		name: 'Eritrea',
		alpha2Code: 'ER',
		callingCode: '+291',
		flag: 'https://flagcdn.com/er.svg',
	},
	{
		name: 'Estonia',
		alpha2Code: 'EE',
		callingCode: '+372',
		flag: 'https://flagcdn.com/ee.svg',
	},
	{
		name: 'Ethiopia',
		alpha2Code: 'ET',
		callingCode: '+251',
		flag: 'https://flagcdn.com/et.svg',
	},
	{
		name: 'Falkland Islands (Malvinas)',
		alpha2Code: 'FK',
		callingCode: '+500',
		flag: 'https://flagcdn.com/fk.svg',
	},
	{
		name: 'Faroe Islands',
		alpha2Code: 'FO',
		callingCode: '+298',
		flag: 'https://flagcdn.com/fo.svg',
	},
	{
		name: 'Fiji',
		alpha2Code: 'FJ',
		callingCode: '+679',
		flag: 'https://flagcdn.com/fj.svg',
	},
	{
		name: 'France',
		alpha2Code: 'FR',
		callingCode: '+33',
		flag: 'https://flagcdn.com/fr.svg',
	},
	{
		name: 'French Guiana',
		alpha2Code: 'GF',
		callingCode: '+594',
		flag: 'https://flagcdn.com/gf.svg',
	},
	{
		name: 'French Polynesia',
		alpha2Code: 'PF',
		callingCode: '+689',
		flag: 'https://flagcdn.com/pf.svg',
	},
	{
		name: 'French Southern Territories',
		alpha2Code: 'TF',
		callingCode: '+262',
		flag: 'https://flagcdn.com/tf.svg',
	},
	{
		name: 'Gabon',
		alpha2Code: 'GA',
		callingCode: '+241',
		flag: 'https://flagcdn.com/ga.svg',
	},
	{
		name: 'Gambia',
		alpha2Code: 'GM',
		callingCode: '+220',
		flag: 'https://flagcdn.com/gm.svg',
	},
	{
		name: 'Georgia',
		alpha2Code: 'GE',
		callingCode: '+995',
		flag: 'https://flagcdn.com/ge.svg',
	},
	{
		name: 'Germany',
		alpha2Code: 'DE',
		callingCode: '+49',
		flag: 'https://flagcdn.com/de.svg',
	},
	{
		name: 'Ghana',
		alpha2Code: 'GH',
		callingCode: '+233',
		flag: 'https://flagcdn.com/gh.svg',
	},
	{
		name: 'Gibraltar',
		alpha2Code: 'GI',
		callingCode: '+350',
		flag: 'https://flagcdn.com/gi.svg',
	},
	{
		name: 'Greece',
		alpha2Code: 'GR',
		callingCode: '+30',
		flag: 'https://flagcdn.com/gr.svg',
	},
	{
		name: 'Greenland',
		alpha2Code: 'GL',
		callingCode: '+299',
		flag: 'https://flagcdn.com/gl.svg',
	},
	{
		name: 'Guadeloupe',
		alpha2Code: 'GP',
		callingCode: '+590',
		flag: 'https://flagcdn.com/gp.svg',
	},
	{
		name: 'Guatemala',
		alpha2Code: 'GT',
		callingCode: '+502',
		flag: 'https://flagcdn.com/gt.svg',
	},
	{
		name: 'Guernsey',
		alpha2Code: 'GG',
		callingCode: '+44',
		flag: 'https://flagcdn.com/gg.svg',
	},
	{
		name: 'Guinea',
		alpha2Code: 'GN',
		callingCode: '+224',
		flag: 'https://flagcdn.com/gn.svg',
	},
	{
		name: 'Guinea-Bissau',
		alpha2Code: 'GW',
		callingCode: '+245',
		flag: 'https://flagcdn.com/gw.svg',
	},
	{
		name: 'Guyana',
		alpha2Code: 'GY',
		callingCode: '+592',
		flag: 'https://flagcdn.com/gy.svg',
	},
	{
		name: 'Haiti',
		alpha2Code: 'HT',
		callingCode: '+509',
		flag: 'https://flagcdn.com/ht.svg',
	},
	{
		name: 'Honduras',
		alpha2Code: 'HN',
		callingCode: '+504',
		flag: 'https://flagcdn.com/hn.svg',
	},
	{
		name: 'Hong Kong',
		alpha2Code: 'HK',
		callingCode: '+852',
		flag: 'https://flagcdn.com/hk.svg',
	},
	{
		name: 'Hungary',
		alpha2Code: 'HU',
		callingCode: '+36',
		flag: 'https://flagcdn.com/hu.svg',
	},
	{
		name: 'Iceland',
		alpha2Code: 'IS',
		callingCode: '+354',
		flag: 'https://flagcdn.com/is.svg',
	},
	{
		name: 'India',
		alpha2Code: 'IN',
		callingCode: '+91',
		flag: 'https://flagcdn.com/in.svg',
	},
	{
		name: 'Indonesia',
		alpha2Code: 'ID',
		callingCode: '+62',
		flag: 'https://flagcdn.com/id.svg',
	},
	{
		name: 'Iran (Islamic Republic of)',
		alpha2Code: 'IR',
		callingCode: '+98',
		flag: 'https://flagcdn.com/ir.svg',
	},
	{
		name: 'Iraq',
		alpha2Code: 'IQ',
		callingCode: '+964',
		flag: 'https://flagcdn.com/iq.svg',
	},
	{
		name: 'Ireland',
		alpha2Code: 'IE',
		callingCode: '+353',
		flag: 'https://flagcdn.com/ie.svg',
	},
	{
		name: 'Israel',
		alpha2Code: 'IL',
		callingCode: '+972',
		flag: 'https://flagcdn.com/il.svg',
	},
	{
		name: 'Italy',
		alpha2Code: 'IT',
		callingCode: '+39',
		flag: 'https://flagcdn.com/it.svg',
	},
	{
		name: 'Ivory Coast',
		alpha2Code: 'CI',
		callingCode: '+225',
		flag: 'https://flagcdn.com/ci.svg',
	},
	{
		name: 'Japan',
		alpha2Code: 'JP',
		callingCode: '+81',
		flag: 'https://flagcdn.com/jp.svg',
	},
	{
		name: 'Jordan',
		alpha2Code: 'JO',
		callingCode: '+962',
		flag: 'https://flagcdn.com/jo.svg',
	},
	{
		name: 'Kazakhstan',
		alpha2Code: 'KZ',
		callingCode: '+76',
		flag: 'https://flagcdn.com/kz.svg',
	},
	{
		name: 'Kenya',
		alpha2Code: 'KE',
		callingCode: '+254',
		flag: 'https://flagcdn.com/ke.svg',
	},
	{
		name: 'Kiribati',
		alpha2Code: 'KI',
		callingCode: '+686',
		flag: 'https://flagcdn.com/ki.svg',
	},
	{
		name: "Korea (Democratic People's Republic of)",
		alpha2Code: 'KP',
		callingCode: '+850',
		flag: 'https://flagcdn.com/kp.svg',
	},
	{
		name: 'Korea (Republic of)',
		alpha2Code: 'KR',
		callingCode: '+82',
		flag: 'https://flagcdn.com/kr.svg',
	},
	{
		name: 'Kuwait',
		alpha2Code: 'KW',
		callingCode: '+965',
		flag: 'https://flagcdn.com/kw.svg',
	},
	{
		name: 'Kyrgyzstan',
		alpha2Code: 'KG',
		callingCode: '+996',
		flag: 'https://flagcdn.com/kg.svg',
	},
	{
		name: "Lao People's Democratic Republic",
		alpha2Code: 'LA',
		callingCode: '+856',
		flag: 'https://flagcdn.com/la.svg',
	},
	{
		name: 'Latvia',
		alpha2Code: 'LV',
		callingCode: '+371',
		flag: 'https://flagcdn.com/lv.svg',
	},
	{
		name: 'Lebanon',
		alpha2Code: 'LB',
		callingCode: '+961',
		flag: 'https://flagcdn.com/lb.svg',
	},
	{
		name: 'Lesotho',
		alpha2Code: 'LS',
		callingCode: '+266',
		flag: 'https://flagcdn.com/ls.svg',
	},
	{
		name: 'Liberia',
		alpha2Code: 'LR',
		callingCode: '+231',
		flag: 'https://flagcdn.com/lr.svg',
	},
	{
		name: 'Libya',
		alpha2Code: 'LY',
		callingCode: '+218',
		flag: 'https://flagcdn.com/ly.svg',
	},
	{
		name: 'Liechtenstein',
		alpha2Code: 'LI',
		callingCode: '+423',
		flag: 'https://flagcdn.com/li.svg',
	},
	{
		name: 'Lithuania',
		alpha2Code: 'LT',
		callingCode: '+370',
		flag: 'https://flagcdn.com/lt.svg',
	},
	{
		name: 'Luxembourg',
		alpha2Code: 'LU',
		callingCode: '+352',
		flag: 'https://flagcdn.com/lu.svg',
	},
	{
		name: 'Macao',
		alpha2Code: 'MO',
		callingCode: '+853',
		flag: 'https://flagcdn.com/mo.svg',
	},
	{
		name: 'Madagascar',
		alpha2Code: 'MG',
		callingCode: '+261',
		flag: 'https://flagcdn.com/mg.svg',
	},
	{
		name: 'Malawi',
		alpha2Code: 'MW',
		callingCode: '+265',
		flag: 'https://flagcdn.com/mw.svg',
	},
	{
		name: 'Malaysia',
		alpha2Code: 'MY',
		callingCode: '+60',
		flag: 'https://flagcdn.com/my.svg',
	},
	{
		name: 'Maldives',
		alpha2Code: 'MV',
		callingCode: '+960',
		flag: 'https://flagcdn.com/mv.svg',
	},
	{
		name: 'Mali',
		alpha2Code: 'ML',
		callingCode: '+223',
		flag: 'https://flagcdn.com/ml.svg',
	},
	{
		name: 'Malta',
		alpha2Code: 'MT',
		callingCode: '+356',
		flag: 'https://flagcdn.com/mt.svg',
	},
	{
		name: 'Marshall Islands',
		alpha2Code: 'MH',
		callingCode: '+692',
		flag: 'https://flagcdn.com/mh.svg',
	},
	{
		name: 'Martinique',
		alpha2Code: 'MQ',
		callingCode: '+596',
		flag: 'https://flagcdn.com/mq.svg',
	},
	{
		name: 'Mauritania',
		alpha2Code: 'MR',
		callingCode: '+222',
		flag: 'https://flagcdn.com/mr.svg',
	},
	{
		name: 'Mauritius',
		alpha2Code: 'MU',
		callingCode: '+230',
		flag: 'https://flagcdn.com/mu.svg',
	},
	{
		name: 'Mexico',
		alpha2Code: 'MX',
		callingCode: '+52',
		flag: 'https://flagcdn.com/mx.svg',
	},
	{
		name: 'Micronesia (Federated States of)',
		alpha2Code: 'FM',
		callingCode: '+691',
		flag: 'https://flagcdn.com/fm.svg',
	},
	{
		name: 'Moldova (Republic of)',
		alpha2Code: 'MD',
		callingCode: '+373',
		flag: 'https://flagcdn.com/md.svg',
	},
	{
		name: 'Monaco',
		alpha2Code: 'MC',
		callingCode: '+377',
		flag: 'https://flagcdn.com/mc.svg',
	},
	{
		name: 'Mongolia',
		alpha2Code: 'MN',
		callingCode: '+976',
		flag: 'https://flagcdn.com/mn.svg',
	},
	{
		name: 'Montenegro',
		alpha2Code: 'ME',
		callingCode: '+382',
		flag: 'https://flagcdn.com/me.svg',
	},
	{
		name: 'Morocco',
		alpha2Code: 'MA',
		callingCode: '+212',
		flag: 'https://flagcdn.com/ma.svg',
	},
	{
		name: 'Mozambique',
		alpha2Code: 'MZ',
		callingCode: '+258',
		flag: 'https://flagcdn.com/mz.svg',
	},
	{
		name: 'Myanmar',
		alpha2Code: 'MM',
		callingCode: '+95',
		flag: 'https://flagcdn.com/mm.svg',
	},
	{
		name: 'Namibia',
		alpha2Code: 'NA',
		callingCode: '+264',
		flag: 'https://flagcdn.com/na.svg',
	},
	{
		name: 'Nauru',
		alpha2Code: 'NR',
		callingCode: '+674',
		flag: 'https://flagcdn.com/nr.svg',
	},
	{
		name: 'Nepal',
		alpha2Code: 'NP',
		callingCode: '+977',
		flag: 'https://flagcdn.com/np.svg',
	},
	{
		name: 'Netherlands',
		alpha2Code: 'NL',
		callingCode: '+31',
		flag: 'https://flagcdn.com/nl.svg',
	},
	{
		name: 'New Caledonia',
		alpha2Code: 'NC',
		callingCode: '+687',
		flag: 'https://flagcdn.com/nc.svg',
	},
	{
		name: 'New Zealand',
		alpha2Code: 'NZ',
		callingCode: '+64',
		flag: 'https://flagcdn.com/nz.svg',
	},
	{
		name: 'Nicaragua',
		alpha2Code: 'NI',
		callingCode: '+505',
		flag: 'https://flagcdn.com/ni.svg',
	},
	{
		name: 'Niger',
		alpha2Code: 'NE',
		callingCode: '+227',
		flag: 'https://flagcdn.com/ne.svg',
	},
	{
		name: 'Nigeria',
		alpha2Code: 'NG',
		callingCode: '+234',
		flag: 'https://flagcdn.com/ng.svg',
	},
	{
		name: 'Niue',
		alpha2Code: 'NU',
		callingCode: '+683',
		flag: 'https://flagcdn.com/nu.svg',
	},
	{
		name: 'North Macedonia',
		alpha2Code: 'MK',
		callingCode: '+389',
		flag: 'https://flagcdn.com/mk.svg',
	},
	{
		name: 'Oman',
		alpha2Code: 'OM',
		callingCode: '+968',
		flag: 'https://flagcdn.com/om.svg',
	},
	{
		name: 'Pakistan',
		alpha2Code: 'PK',
		callingCode: '+92',
		flag: 'https://flagcdn.com/pk.svg',
	},
	{
		name: 'Palau',
		alpha2Code: 'PW',
		callingCode: '+680',
		flag: 'https://flagcdn.com/pw.svg',
	},
	{
		name: 'Palestine, State of',
		alpha2Code: 'PS',
		callingCode: '+970',
		flag: 'https://flagcdn.com/ps.svg',
	},
	{
		name: 'Panama',
		alpha2Code: 'PA',
		callingCode: '+507',
		flag: 'https://flagcdn.com/pa.svg',
	},
	{
		name: 'Papua New Guinea',
		alpha2Code: 'PG',
		callingCode: '+675',
		flag: 'https://flagcdn.com/pg.svg',
	},
	{
		name: 'Paraguay',
		alpha2Code: 'PY',
		callingCode: '+595',
		flag: 'https://flagcdn.com/py.svg',
	},
	{
		name: 'Peru',
		alpha2Code: 'PE',
		callingCode: '+51',
		flag: 'https://flagcdn.com/pe.svg',
	},
	{
		name: 'Philippines',
		alpha2Code: 'PH',
		callingCode: '+63',
		flag: 'https://flagcdn.com/ph.svg',
	},
	{
		name: 'Poland',
		alpha2Code: 'PL',
		callingCode: '+48',
		flag: 'https://flagcdn.com/pl.svg',
	},
	{
		name: 'Portugal',
		alpha2Code: 'PT',
		callingCode: '+351',
		flag: 'https://flagcdn.com/pt.svg',
	},
	{
		name: 'Qatar',
		alpha2Code: 'QA',
		callingCode: '+974',
		flag: 'https://flagcdn.com/qa.svg',
	},
	{
		name: 'Republic of Kosovo',
		alpha2Code: 'XK',
		callingCode: '+383',
		flag: 'https://flagcdn.com/xk.svg',
	},
	{
		name: 'Romania',
		alpha2Code: 'RO',
		callingCode: '+40',
		flag: 'https://flagcdn.com/ro.svg',
	},
	{
		name: 'Russian Federation',
		alpha2Code: 'RU',
		callingCode: '+7',
		flag: 'https://flagcdn.com/ru.svg',
	},
	{
		name: 'Rwanda',
		alpha2Code: 'RW',
		callingCode: '+250',
		flag: 'https://flagcdn.com/rw.svg',
	},
	{
		name: 'Saint Helena, Ascension and Tristan da Cunha',
		alpha2Code: 'SH',
		callingCode: '+290',
		flag: 'https://flagcdn.com/sh.svg',
	},
	{
		name: 'Saint Pierre and Miquelon',
		alpha2Code: 'PM',
		callingCode: '+508',
		flag: 'https://flagcdn.com/pm.svg',
	},
	{
		name: 'Samoa',
		alpha2Code: 'WS',
		callingCode: '+685',
		flag: 'https://flagcdn.com/ws.svg',
	},
	{
		name: 'San Marino',
		alpha2Code: 'SM',
		callingCode: '+378',
		flag: 'https://flagcdn.com/sm.svg',
	},
	{
		name: 'Sao Tome and Principe',
		alpha2Code: 'ST',
		callingCode: '+239',
		flag: 'https://flagcdn.com/st.svg',
	},
	{
		name: 'Saudi Arabia',
		alpha2Code: 'SA',
		callingCode: '+966',
		flag: 'https://flagcdn.com/sa.svg',
	},
	{
		name: 'Senegal',
		alpha2Code: 'SN',
		callingCode: '+221',
		flag: 'https://flagcdn.com/sn.svg',
	},
	{
		name: 'Serbia',
		alpha2Code: 'RS',
		callingCode: '+381',
		flag: 'https://flagcdn.com/rs.svg',
	},
	{
		name: 'Seychelles',
		alpha2Code: 'SC',
		callingCode: '+248',
		flag: 'https://flagcdn.com/sc.svg',
	},
	{
		name: 'Sierra Leone',
		alpha2Code: 'SL',
		callingCode: '+232',
		flag: 'https://flagcdn.com/sl.svg',
	},
	{
		name: 'Singapore',
		alpha2Code: 'SG',
		callingCode: '+65',
		flag: 'https://flagcdn.com/sg.svg',
	},
	{
		name: 'Slovakia',
		alpha2Code: 'SK',
		callingCode: '+421',
		flag: 'https://flagcdn.com/sk.svg',
	},
	{
		name: 'Slovenia',
		alpha2Code: 'SI',
		callingCode: '+386',
		flag: 'https://flagcdn.com/si.svg',
	},
	{
		name: 'Solomon Islands',
		alpha2Code: 'SB',
		callingCode: '+677',
		flag: 'https://flagcdn.com/sb.svg',
	},
	{
		name: 'Somalia',
		alpha2Code: 'SO',
		callingCode: '+252',
		flag: 'https://flagcdn.com/so.svg',
	},
	{
		name: 'South Africa',
		alpha2Code: 'ZA',
		callingCode: '+27',
		flag: 'https://flagcdn.com/za.svg',
	},
	{
		name: 'South Sudan',
		alpha2Code: 'SS',
		callingCode: '+211',
		flag: 'https://flagcdn.com/ss.svg',
	},
	{
		name: 'Spain',
		alpha2Code: 'ES',
		callingCode: '+34',
		flag: 'https://flagcdn.com/es.svg',
	},
	{
		name: 'Sri Lanka',
		alpha2Code: 'LK',
		callingCode: '+94',
		flag: 'https://flagcdn.com/lk.svg',
	},
	{
		name: 'Sudan',
		alpha2Code: 'SD',
		callingCode: '+249',
		flag: 'https://flagcdn.com/sd.svg',
	},
	{
		name: 'Suriname',
		alpha2Code: 'SR',
		callingCode: '+597',
		flag: 'https://flagcdn.com/sr.svg',
	},
	{
		name: 'Swaziland',
		alpha2Code: 'SZ',
		callingCode: '+268',
		flag: 'https://flagcdn.com/sz.svg',
	},
	{
		name: 'Sweden',
		alpha2Code: 'SE',
		callingCode: '+46',
		flag: 'https://flagcdn.com/se.svg',
	},
	{
		name: 'Switzerland',
		alpha2Code: 'CH',
		callingCode: '+41',
		flag: 'https://flagcdn.com/ch.svg',
	},
	{
		name: 'Syrian Arab Republic',
		alpha2Code: 'SY',
		callingCode: '+963',
		flag: 'https://flagcdn.com/sy.svg',
	},
	{
		name: 'Taiwan',
		alpha2Code: 'TW',
		callingCode: '+886',
		flag: 'https://flagcdn.com/tw.svg',
	},
	{
		name: 'Tajikistan',
		alpha2Code: 'TJ',
		callingCode: '+992',
		flag: 'https://flagcdn.com/tj.svg',
	},
	{
		name: 'Tanzania, United Republic of',
		alpha2Code: 'TZ',
		callingCode: '+255',
		flag: 'https://flagcdn.com/tz.svg',
	},
	{
		name: 'Thailand',
		alpha2Code: 'TH',
		callingCode: '+66',
		flag: 'https://flagcdn.com/th.svg',
	},
	{
		name: 'Timor-Leste',
		alpha2Code: 'TL',
		callingCode: '+670',
		flag: 'https://flagcdn.com/tl.svg',
	},
	{
		name: 'Togo',
		alpha2Code: 'TG',
		callingCode: '+228',
		flag: 'https://flagcdn.com/tg.svg',
	},
	{
		name: 'Tokelau',
		alpha2Code: 'TK',
		callingCode: '+690',
		flag: 'https://flagcdn.com/tk.svg',
	},
	{
		name: 'Tonga',
		alpha2Code: 'TO',
		callingCode: '+676',
		flag: 'https://flagcdn.com/to.svg',
	},
	{
		name: 'Tunisia',
		alpha2Code: 'TN',
		callingCode: '+216',
		flag: 'https://flagcdn.com/tn.svg',
	},
	{
		name: 'Turkey',
		alpha2Code: 'TR',
		callingCode: '+90',
		flag: 'https://flagcdn.com/tr.svg',
	},
	{
		name: 'Turkmenistan',
		alpha2Code: 'TM',
		callingCode: '+993',
		flag: 'https://flagcdn.com/tm.svg',
	},
	{
		name: 'Tuvalu',
		alpha2Code: 'TV',
		callingCode: '+688',
		flag: 'https://flagcdn.com/tv.svg',
	},
	{
		name: 'Uganda',
		alpha2Code: 'UG',
		callingCode: '+256',
		flag: 'https://flagcdn.com/ug.svg',
	},
	{
		name: 'Ukraine',
		alpha2Code: 'UA',
		callingCode: '+380',
		flag: 'https://flagcdn.com/ua.svg',
	},
	{
		name: 'United Arab Emirates',
		alpha2Code: 'AE',
		callingCode: '+971',
		flag: 'https://flagcdn.com/ae.svg',
	},
	{
		name: 'Uruguay',
		alpha2Code: 'UY',
		callingCode: '+598',
		flag: 'https://flagcdn.com/uy.svg',
	},
	{
		name: 'Uzbekistan',
		alpha2Code: 'UZ',
		callingCode: '+998',
		flag: 'https://flagcdn.com/uz.svg',
	},
	{
		name: 'Vanuatu',
		alpha2Code: 'VU',
		callingCode: '+678',
		flag: 'https://flagcdn.com/vu.svg',
	},
	{
		name: 'Vatican City',
		alpha2Code: 'VA',
		callingCode: '+379',
		flag: 'https://flagcdn.com/va.svg',
	},
	{
		name: 'Venezuela (Bolivarian Republic of)',
		alpha2Code: 'VE',
		callingCode: '+58',
		flag: 'https://flagcdn.com/ve.svg',
	},
	{
		name: 'Vietnam',
		alpha2Code: 'VN',
		callingCode: '+84',
		flag: 'https://flagcdn.com/vn.svg',
	},
	{
		name: 'Virgin Islands (U.S.)',
		alpha2Code: 'VI',
		callingCode: '+1 340',
		flag: 'https://flagcdn.com/vi.svg',
	},
	{
		name: 'Wallis and Futuna',
		alpha2Code: 'WF',
		callingCode: '+681',
		flag: 'https://flagcdn.com/wf.svg',
	},
	{
		name: 'Yemen',
		alpha2Code: 'YE',
		callingCode: '+967',
		flag: 'https://flagcdn.com/ye.svg',
	},
	{
		name: 'Zambia',
		alpha2Code: 'ZM',
		callingCode: '+260',
		flag: 'https://flagcdn.com/zm.svg',
	},
	{
		name: 'Zimbabwe',
		alpha2Code: 'ZW',
		callingCode: '+263',
		flag: 'https://flagcdn.com/zw.svg',
	},
	{
		name: 'Åland Islands',
		alpha2Code: 'AX',
		callingCode: '+358',
		flag: 'https://flagcdn.com/ax.svg',
	},
]
